import { useState } from 'react';
import { useApolloClient } from 'react-apollo';

import { AccountPromoCodeVerify } from '../../../graphql/queries/account-referrals';
import { CURRENCY } from '../../../constants/currency';
import { getErrorString } from '../../../util/normalize-errors';

const usePromoCode = ({ onError, onPromoCodeVerified }) => {
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();

  const onPromoCodeVerify = async ({
    promoCode,
    price,
    accountReferralTypes = [],
  }) => {
    try {
      setLoading(true);

      const {
        data: { accountPromoCodeVerify: accountPromoCode } = {},
      } = await client.query({
        query: AccountPromoCodeVerify,
        variables: {
          promoCode,
          price: price
            ? {
                value: price,
                currency: CURRENCY.USD,
              }
            : undefined,
        },
        fetchPolicy: 'network-only',
      });

      if (accountPromoCode.type == null) {
        onError?.(new Error('The provided promo code is invalid'));
        return null;
      }

      if (!accountReferralTypes.includes(accountPromoCode.type)) {
        onError?.(new Error('This promo code does not apply for this action.'));
        return null;
      }

      if (accountPromoCode.is_valid && accountPromoCode.is_eligible) {
        onPromoCodeVerified?.(accountPromoCode);
        return accountPromoCode;
      }

      if (!accountPromoCode.is_eligible) {
        onError?.(
          new Error(
            'Sorry, it looks like you do not apply for this promotion.',
          ),
        );
      } else {
        onError?.(new Error('The provided promo code is invalid'));
      }

      return null;
    } catch (error) {
      onError?.(getErrorString(error));
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    onPromoCodeVerify,
    loading,
  };
};

export default usePromoCode;
